/* royme — sezioni: Senza/Con (volume), file di schede che scorrono (anche col dito), conto alla rovescia */
(function () {
  'use strict';
  if (window.__rySectionsLoaded) return;
  window.__rySectionsLoaded = true;

  var calmo = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* ---------- Volume: «Senza» e «Con» ---------- */
  function suono(root) {
    if (!root || root.__ryOk) return;
    root.__ryOk = true;
    var bottoni = root.querySelectorAll('[data-ry-sound-set]');
    var toccato = false;
    function metti(stato) {
      root.setAttribute('data-state', stato);
      each(bottoni, function (b) {
        var on = b.getAttribute('data-ry-sound-set') === stato;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    each(bottoni, function (b) {
      b.addEventListener('click', function () { toccato = true; metti(b.getAttribute('data-ry-sound-set')); });
    });
    // La prima volta che la sezione si vede, dopo un attimo passa da sola a «Con».
    if (root.getAttribute('data-auto') === 'true' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting) return;
          io.disconnect();
          setTimeout(function () { if (!toccato) metti('on'); }, 1600);
        });
      }, { threshold: 0.45 });
      io.observe(root);
    }
  }

  /* ---------- Schede in fila: scorrono piano verso sinistra e si possono far scorrere col dito ---------- */
  function fila(root) {
    if (!root || root.__ryOk) return;
    var lista = root.querySelector('[data-ry-marquee-list]');
    if (!lista) return;
    root.__ryOk = true;
    if (root.hasAttribute('data-static') || calmo.matches || lista.children.length < 2) return;
    var velocita = Number(root.getAttribute('data-speed')) || 30;
    var binario = document.createElement('div');
    binario.className = 'ry-marquee__track';
    lista.parentNode.insertBefore(binario, lista);
    binario.appendChild(lista);
    var chiave = '', largo = 0, frame, attesa, dito = false, fermo = false;
    function costruisci() {
      var l = lista.getBoundingClientRect().width, vista = root.clientWidth;
      var k = Math.round(l) + ':' + vista;
      if (k === chiave) return;
      chiave = k;
      root.classList.remove('is-moving');
      largo = 0;
      each(binario.querySelectorAll('[data-ry-copia]'), function (n) { n.parentNode.removeChild(n); });
      if (!l || !vista) return;
      // Copie in più: servono al giro infinito e a far scorrere col dito avanti e indietro.
      for (var i = 0, n = 3 + Math.ceil(vista / l); i < n; i++) {
        var c = lista.cloneNode(true);
        c.removeAttribute('data-ry-marquee-list');
        c.setAttribute('data-ry-copia', '');
        c.setAttribute('aria-hidden', 'true');
        each(c.querySelectorAll('[data-shopify-editor-block]'), function (x) { x.removeAttribute('data-shopify-editor-block'); });
        each(c.querySelectorAll('a, button, input, [tabindex]'), function (x) { x.setAttribute('tabindex', '-1'); });
        binario.appendChild(c);
      }
      largo = l;
      root.style.setProperty('--ry-m-w', l + 'px');
      root.style.setProperty('--ry-m-dur', (l / velocita).toFixed(2) + 's');
      root.scrollLeft = l;
      void root.offsetWidth;
      root.classList.add('is-moving');
    }
    function aggiorna() { cancelAnimationFrame(frame); frame = requestAnimationFrame(costruisci); }
    // Lo scroll resta nella seconda copia: il salto non si vede, perché le copie sono uguali.
    function rimetti() {
      if (!largo) return;
      var s = root.scrollLeft;
      while (s >= 2 * largo) s -= largo;
      while (s < largo) s += largo;
      if (Math.abs(s - root.scrollLeft) > 1) root.scrollLeft = s;
    }
    // Col dito o col trackpad la fila si ferma e scorre a mano; riparte da sola poco dopo.
    function ferma() { clearTimeout(attesa); fermo = true; root.classList.add('is-held'); }
    function riparti(dopo) {
      clearTimeout(attesa);
      attesa = setTimeout(function () {
        if (dito) return;
        rimetti();
        fermo = false;
        root.classList.remove('is-held');
      }, dopo);
    }
    function lascia() { dito = false; riparti(1800); }
    root.addEventListener('touchstart', function () { dito = true; ferma(); }, { passive: true });
    root.addEventListener('touchend', lascia, { passive: true });
    root.addEventListener('touchcancel', lascia, { passive: true });
    root.addEventListener('scroll', function () { if (fermo && !dito) riparti(1800); }, { passive: true });
    root.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { ferma(); riparti(1800); } }, { passive: true });
    root.addEventListener('focusin', ferma);
    root.addEventListener('focusout', function () { riparti(0); });
    document.addEventListener('shopify:block:select', function (e) { if (root.contains(e.target)) ferma(); });
    document.addEventListener('shopify:block:deselect', function (e) { if (root.contains(e.target)) riparti(0); });
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(aggiorna); ro.observe(root); ro.observe(lista); }
    else window.addEventListener('resize', aggiorna);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { root.classList.toggle('is-away', !v.isIntersecting); });
      }).observe(root);
    }
    aggiorna();
  }

  /* ---------- «Mancano N giorni a Capodanno» (dal 1° ottobre al 22 dicembre) ---------- */
  function contoAllaRovescia(el) {
    if (!el || el.__ryOk) return;
    el.__ryOk = true;
    var oggi = new Date();
    var anno = oggi.getFullYear();
    var giorno = new Date(anno, oggi.getMonth(), oggi.getDate());
    if (giorno < new Date(anno, 9, 1) || giorno > new Date(anno, 11, 22)) { el.hidden = true; return; }
    var n = Math.round((new Date(anno, 11, 31) - giorno) / 86400000);
    var testo = (el.getAttribute('data-text') || 'Mancano [n] giorni a Capodanno.')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var dove = el.querySelector('[data-ry-countdown-text]');
    if (!dove) return;
    dove.innerHTML = testo.replace('[n]', '<strong>' + n + '</strong>');
    el.hidden = false;
  }

  /* ---------- Video verticali: partono da soli quando si vedono, un tocco li ferma ---------- */
  function video(c) {
    if (!c || c.__ryOk) return;
    c.__ryOk = true;
    var v = c.querySelector('video');
    if (!v) return;
    v.muted = true;
    function parti() {
      if (c.classList.contains('is-held')) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    c.addEventListener('click', function () {
      if (v.paused) { c.classList.remove('is-held'); parti(); }
      else { v.pause(); c.classList.add('is-held'); }
    });
    v.addEventListener('playing', function () { c.classList.add('is-playing'); });
    v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
    if (calmo.matches) { c.classList.add('is-held'); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (e) { if (e.isIntersecting) parti(); else if (!v.paused) v.pause(); });
      }, { threshold: 0.25 }).observe(c);
    } else parti();
  }

  /* ---------- Video sotto i pagamenti: fila che scorre da sola, all'infinito ----------
     Le schede girano in tondo (nessuna copia dei video): scorrono piano verso sinistra e ricominciano senza salti.
     Col mouse sopra rallentano e si fermano; col dito o col mouse si trascinano e poi ripartono da sole.
     Ogni video si carica poco prima di entrare e si ferma quando esce, così si scarica solo quello che si vede.
     La foto del video resta sopra finché il primo fotogramma non è pronto: niente schermo nero. */
  function rullo(root) {
    if (!root || root.__ryOk) return;
    var binario = root.querySelector('[data-ry-reel-track]');
    if (!binario || !binario.children.length) return;
    root.__ryOk = true;

    var originali = Array.prototype.slice.call(binario.children);
    var manuale = calmo.matches;
    var auto = root.getAttribute('data-auto') !== 'false' && !manuale;
    var velocita = Math.max(4, Number(root.getAttribute('data-speed')) || 24);
    var schede = [], passo = 0, giro = 0, vista = 0, largo = 0, chiave = '';
    var x = 0, vel = 0, spinta = 0, inTondo = false, visibile = false, frame = 0, prima = 0;
    var pause = {}, attese = {}, elenchi = {}, bloccati = false, dito = null, mossoAlle = 0;

    if (manuale) root.classList.add('is-manual');

    function scheda(el) {
      if (!el.__ry) {
        el.__ry = { el: el, v: el.querySelector('video'), tx: null, vicino: false, va: false, pronto: false, rotto: false, mano: false };
        if (el.__ry.v) prepara(el.__ry);
      }
      return el.__ry;
    }

    function prepara(s) {
      var v = s.v;
      v.muted = true;
      v.playsInline = true;
      v.addEventListener('playing', function () {
        s.el.classList.add('is-playing');
        if (s.pronto) return;
        var vivo = function () {
          if (s.pronto) return;
          s.pronto = true;
          s.el.classList.add('is-live');
        };
        if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(vivo);
        else if (v.currentTime > 0) vivo();
        else v.addEventListener('timeupdate', function t() {
          if (v.currentTime > 0) { v.removeEventListener('timeupdate', t); vivo(); }
        });
      });
      v.addEventListener('pause', function () { s.el.classList.remove('is-playing'); });
      v.addEventListener('error', function () {
        var hd = s.el.getAttribute('data-hd');
        if (hd && s.src !== hd && !s.riprova) {
          // La versione leggera non si carica: si torna a quella originale.
          s.riprova = true;
          s.src = hd;
          v.src = hd;
          if (s.va) accendi(s);
          return;
        }
        s.rotto = true;
        s.el.classList.remove('is-playing');
      });
    }

    // Shopify nella pagina dà solo la versione 1080p (pesante: fino a 10 MB per video).
    // Dall'elenco delle versioni (.m3u8, stesso indirizzo del video) si prende quella giusta:
    // 480p sul telefono, 720p sui computer con schermo nitido. Se qualcosa non va, resta la 1080p.
    function varianti(hd) {
      var u;
      try { u = new URL(hd, window.location.href); } catch (err) { return Promise.resolve([]); }
      var lista = u.origin + u.pathname.replace(/\.[^\/.]+-[^\/]*\.mp4$/, '.m3u8');
      if (!window.fetch || !/\.m3u8$/.test(lista)) return Promise.resolve([]);
      if (!elenchi[lista]) {
        var cartella = lista.replace(/[^\/]+$/, '');
        elenchi[lista] = fetch(lista).then(function (r) { return r.ok ? r.text() : ''; }).then(function (testo) {
          var righe = testo.split('\n'), trovate = [];
          for (var i = 0; i < righe.length - 1; i++) {
            var m = /RESOLUTION=(\d+)x(\d+)/.exec(righe[i]);
            var uri = (righe[i + 1] || '').trim();
            var mp4 = uri.replace(/^([^\/]+?)\.((?:SD|HD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/, '$1.$2-$3-$4.mp4');
            if (m && mp4 !== uri) trovate.push({ h: +m[2], url: cartella + mp4 });
          }
          return trovate;
        }).catch(function () { return []; });
      }
      return elenchi[lista];
    }

    function sorgente(s) {
      if (s.promessa) return s.promessa;
      var el = s.el, hd = el.getAttribute('data-hd') || '', sd = el.getAttribute('data-sd') || hd;
      var c = navigator.connection || {};
      var lento = c.saveData || /(^|-)(2g|3g)$/.test(c.effectiveType || '');
      var nitido = !lento && window.matchMedia('(min-width: 750px)').matches &&
        el.getBoundingClientRect().width * (window.devicePixelRatio || 1) > 300;
      var scegli = sd !== hd ? Promise.resolve(nitido ? hd : sd) : varianti(hd).then(function (trovate) {
        var meta = nitido ? 720 : 480, scelta = null, minima = null;
        trovate.forEach(function (x) {
          if (x.h <= meta && (!scelta || x.h > scelta.h)) scelta = x;
          if (!minima || x.h < minima.h) minima = x;
        });
        return (scelta || minima || { url: hd }).url;
      });
      s.promessa = scegli.then(function (src) { s.src = src || hd; return s.src; });
      return s.promessa;
    }

    function accendi(s) {
      if (!s.v || s.rotto) return null;
      if (!s.v.getAttribute('src')) {
        if (!s.src) {
          sorgente(s).then(function () { if (s.va && !s.v.getAttribute('src')) accendi(s); });
          return null;
        }
        s.v.preload = 'auto';
        s.v.src = s.src;
      }
      var p = s.v.play();
      if (p && p.catch) p.catch(function (err) {
        // Il telefono non lascia partire i video da soli (es. risparmio energetico): basta un tocco.
        if (err && err.name === 'NotAllowedError') {
          bloccati = true;
          s.va = false;
          root.classList.add('is-blocked');
        }
      });
      return p;
    }

    function spegni(s) {
      if (s.v && !s.v.paused) s.v.pause();
    }

    function regola(s) {
      if (!s.v) return;
      var vuole = visibile && s.vicino && !bloccati && !document.hidden && (manuale ? s.mano : true);
      if (vuole === s.va) return;
      s.va = vuole;
      if (vuole) accendi(s); else spegni(s);
    }

    function copia(el) {
      var c = el.cloneNode(true);
      c.setAttribute('data-ry-copia', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
      c.classList.remove('is-live', 'is-playing');
      var v = c.querySelector('video');
      if (v) { v.removeAttribute('src'); v.preload = 'none'; }
      return c;
    }

    function misura() {
      var w = originali[0].getBoundingClientRect().width;
      var v = root.clientWidth;
      if (!w || !v) return;
      var gap = parseFloat(getComputedStyle(binario).columnGap) || 0;
      var k = [w, v, gap].map(function (n) { return Math.round(n * 10); }).join(':');
      if (k === chiave) return;
      chiave = k;
      largo = w;
      passo = w + gap;
      vista = v;
      inTondo = originali.length * passo - gap > vista + 1;
      // Con pochi video (meno di quelli che riempiono la fila più uno) servono delle copie per il giro.
      var servono = inTondo ? Math.max(originali.length, Math.ceil(vista / passo) + 1) : originali.length;
      each(binario.querySelectorAll('[data-ry-copia]'), function (n) { n.parentNode.removeChild(n); });
      for (var i = originali.length; i < servono; i++) binario.appendChild(copia(originali[i % originali.length]));
      schede = Array.prototype.map.call(binario.children, scheda);
      giro = schede.length * passo;
      root.classList.toggle('is-moving', inTondo);
      if (!inTondo) { x = 0; spinta = 0; }
      disegna();
      parti();
    }

    function disegna() {
      if (inTondo && giro) x = ((x % giro) + giro) % giro;
      for (var i = 0; i < schede.length; i++) {
        var s = schede[i], base = i * passo, p = base;
        if (inTondo) {
          p = (((base - x) % giro) + giro) % giro;
          if (p > giro - passo) p -= giro;
        }
        var tx = Math.round((p - base) * 100) / 100;
        if (tx !== s.tx) {
          s.tx = tx;
          s.el.style.transform = tx ? 'translate3d(' + tx + 'px,0,0)' : '';
        }
        s.vicino = p < vista + passo * 0.6 && p + largo > -passo * 0.6;
        regola(s);
      }
    }

    function ferma() {
      for (var k in pause) if (pause[k]) return true;
      return false;
    }

    function ciclo(t) {
      frame = requestAnimationFrame(ciclo);
      var dt = prima ? Math.min(0.05, (t - prima) / 1000) : 0;
      prima = t;
      var meta = auto && inTondo && !ferma() ? velocita : 0;
      vel += (meta - vel) * Math.min(1, dt * 2.6);
      if (!meta && Math.abs(vel) < 0.05) vel = 0;
      if (!dito) {
        if (spinta) {
          x += spinta * dt;
          spinta *= Math.exp(-dt * 4.5);
          if (Math.abs(spinta) < 6) spinta = 0;
        }
        x += vel * dt;
      }
      disegna();
    }

    function parti() {
      if (!visibile || document.hidden) return;
      if (!inTondo) { disegna(); return; }
      if (frame) return;
      prima = 0;
      frame = requestAnimationFrame(ciclo);
    }

    function sosta() {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      schede.forEach(regola);
    }

    function tieni(motivo) {
      clearTimeout(attese[motivo]);
      pause[motivo] = true;
    }

    function lascia(motivo, dopo) {
      clearTimeout(attese[motivo]);
      if (!dopo) { pause[motivo] = false; return; }
      attese[motivo] = setTimeout(function () { pause[motivo] = false; }, dopo);
    }

    // Dopo un tocco, se il telefono aveva bloccato i video, li fa partire tutti (e ferma quelli fuori dalla fila).
    function sblocca() {
      bloccati = false;
      root.classList.remove('is-blocked');
      schede.forEach(function (s) {
        if (!s.v || s.rotto) return;
        s.va = true;
        var p = accendi(s);
        if (p && p.then) p.then(function () {
          if (!(visibile && s.vicino)) { s.va = false; s.v.pause(); }
        }, function () {});
      });
    }

    function tocco(e) {
      if (bloccati) { sblocca(); return; }
      if (!manuale) return;
      var el = e.target && e.target.closest ? e.target.closest('[data-ry-reel-item]') : null;
      var s = el && el.__ry;
      if (!s || !s.v) return;
      s.mano = !s.mano;
      s.va = s.mano;
      if (s.mano) accendi(s); else spegni(s);
    }

    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') tieni('mouse'); });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') lascia('mouse', 200); });

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dito = { id: e.pointerId, x0: e.clientX, y0: e.clientY, xs: x, mosso: false, punti: [[e.timeStamp, e.clientX]] };
      spinta = 0;
      vel = 0;
      tieni('dito');
    });

    root.addEventListener('pointermove', function (e) {
      if (!dito || e.pointerId !== dito.id) return;
      var dx = e.clientX - dito.x0, dy = e.clientY - dito.y0;
      if (!dito.mosso) {
        if (!inTondo || Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
        dito.mosso = true;
        dito.x0 = e.clientX;
        dito.xs = x;
        root.classList.add('is-dragging');
        try { root.setPointerCapture(e.pointerId); } catch (err) {}
        dx = 0;
      }
      x = dito.xs - dx;
      dito.punti.push([e.timeStamp, e.clientX]);
      if (dito.punti.length > 8) dito.punti.shift();
      disegna();
    });

    function fine(e, annullato) {
      if (!dito || e.pointerId !== dito.id) return;
      var d = dito;
      dito = null;
      root.classList.remove('is-dragging');
      if (d.mosso) {
        mossoAlle = Date.now();
        var b = d.punti[d.punti.length - 1], a = b;
        for (var i = d.punti.length - 1; i >= 0 && b[0] - d.punti[i][0] <= 100; i--) a = d.punti[i];
        var ms = b[0] - a[0];
        spinta = !annullato && ms > 16 && e.timeStamp - b[0] < 90
          ? Math.max(-2400, Math.min(2400, -(b[1] - a[1]) / ms * 1000)) : 0;
        lascia('dito', 1600);
      } else {
        lascia('dito', annullato ? 1200 : 2400);
        if (!annullato) tocco(e);
      }
    }
    root.addEventListener('pointerup', function (e) { fine(e, false); });
    root.addEventListener('pointercancel', function (e) { fine(e, true); });
    root.addEventListener('lostpointercapture', function (e) { if (e.target === root && dito && dito.mosso) fine(e, true); });
    // Dopo un trascinamento il clic che segue non deve aprire nulla.
    root.addEventListener('click', function (e) {
      if (Date.now() - mossoAlle < 350) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });

    root.addEventListener('wheel', function (e) {
      if (!inTondo || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      x += e.deltaX * (e.deltaMode === 1 ? 16 : 1);
      spinta = 0;
      tieni('rotella');
      lascia('rotella', 1400);
      disegna();
    }, { passive: false });

    // Da tastiera: col fuoco sulla fila si ferma, le frecce la spostano di un video.
    root.addEventListener('focusin', function () {
      var tastiera = false;
      try { tastiera = root.matches(':focus-visible'); } catch (err) {}
      if (tastiera) tieni('fuoco');
    });
    root.addEventListener('focusout', function () { lascia('fuoco', 0); });
    root.addEventListener('keydown', function (e) {
      if (!inTondo || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      spinta = (e.key === 'ArrowRight' ? 1 : -1) * passo * 4.5;
    });

    // Nell'editor del tema: scegliendo un video la fila si ferma su quello.
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-ry-reel-item]') : null;
      if (!el || !root.contains(el)) return;
      tieni('editor');
      var i = schede.indexOf(el.__ry);
      if (inTondo && i >= 0) { x = i * passo; spinta = 0; vel = 0; disegna(); }
      root.scrollLeft = 0;
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (e.target && root.contains(e.target)) lascia('editor', 0);
    });
    root.addEventListener('scroll', function () { if (root.scrollLeft) root.scrollLeft = 0; }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) sosta(); else parti();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          visibile = v.isIntersecting;
          if (visibile) {
            schede.forEach(function (s) { if (s.v) sorgente(s); });
            parti();
          } else sosta();
        });
      }, { rootMargin: '300px 0px' }).observe(root);
    } else {
      visibile = true;
    }

    if ('ResizeObserver' in window) new ResizeObserver(misura).observe(root);
    else window.addEventListener('resize', misura);
    misura();
  }

  function avvia(scope) {
    scope = scope || document;
    each(scope.querySelectorAll('[data-ry-reel]'), rullo);
    each(scope.querySelectorAll('[data-ry-clip]'), video);
    each(scope.querySelectorAll('[data-ry-sound]'), suono);
    each(scope.querySelectorAll('[data-ry-marquee]'), fila);
    each(scope.querySelectorAll('[data-ry-countdown]'), contoAllaRovescia);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { avvia(); });
  else avvia();
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();